module.exports = __webpack_public_path__ + "static/media/books.82de0f01.png";